module.exports = __webpack_public_path__ + "img/alerts-1.7f7a4505.gif";